// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  position: relative;
  margin-top: 40px;
  width: 100%;
}
.carousel .controls {
  display: flex;
  position: absolute;
  right: 0;
  margin-top: 32px;
}
.carousel .controls .btn {
  padding: 0;
  opacity: 0.5;
}
.carousel .controls .btn:hover {
  opacity: 1;
}
.carousel .controls .btn svg {
  width: 35rem !important;
}
.carousel .controls .btn.left {
  margin-right: 40px;
  transform: rotate(180deg);
}
.carousel .gallery {
  width: 100%;
  overflow: auto;
}
.carousel .gallery ul {
  width: max-content;
  margin: 0;
  padding: 0;
  list-style: none;
  transition: margin-left 250ms;
  font-size: 0;
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/Carousel/ui/Carousel.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;AACJ;AAJA;EAMQ,aAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;AACR;AAVA;EAWY,UAAA;EACA,YAAA;AAEZ;AADY;EACI,UAAA;AAGhB;AAjBA;EAiBgB,uBAAA;AAGhB;AADY;EACI,kBAAA;EACA,yBAAA;AAGhB;AAxBA;EA2BQ,WAAA;EACA,cAAA;AAAR;AA5BA;EA+BY,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;AAAZ","sourcesContent":[".carousel {\n    position: relative;\n    margin-top: 40px;\n    width: 100%;\n\n    .controls {\n        display: flex;\n        position: absolute;\n        right: 0;\n        margin-top: 32px;\n        .btn {\n            padding: 0;\n            opacity: 0.5;\n            &:hover {\n                opacity: 1;\n            }\n            svg {\n                width: 35rem !important;\n            }\n            &.left {\n                margin-right: 40px;\n                transform: rotate(180deg);\n            }\n        }\n    }\n\n    .gallery {\n        width: 100%;\n        overflow: auto;\n\n        ul {\n            width: max-content;\n            margin: 0;\n            padding: 0;\n            list-style: none;\n            transition: margin-left 250ms;\n            font-size: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
